import { render, staticRenderFns } from "./ModalShareQr.vue?vue&type=template&id=4284c179"
import script from "./ModalShareQr.vue?vue&type=script&lang=js"
export * from "./ModalShareQr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports